<template>
  <div class="home">
    <Header title="Home" />

    <div class="homepage-hero-wrapper">
      <div class="homepage-hero">
        <div class="brand-introduction">
          <div class="brand-title">
            <h1 class="home-header">Mod<span class="outline-text">Cord</span>,</h1>
            <h1 class="home-header">Moderation made easy</h1> 
          </div>
          <div class="brand-description">
            <p>
              ModCord is the moderation bot that takes your server's security to a whole new
              level with a wide range of features like a powerful automod, raid detection,
              server lockdown, custom commands, beautiful logs and much more.
            </p>
          </div>
          <div class="brand-buttons">
            <a class="form-button" href="/dashboard"><i class="fas fa-plus"></i> Invite ModCord</a>
            <a class="form-button margin-left-btn" href="/support"><i class="fas fa-headset"></i> Help & Support</a>
          </div>
        </div>
        <div class="brand-illustration">
          <img v-bind:src="`${$cdnUrl}/assets/${thumbnail.name}`" v-bind:style="`width: ${thumbnail.width};`" alt="Brand Hero Illustration">
        </div>
      </div>

      <div class="homepage-hero-wave">
        <img v-bind:src="`${$cdnUrl}/assets/frontpage-hero-wave.svg`" alt="Brand Hero Wave">
      </div>
    </div>

    <div class="homepage-feature-wrapper">
      <div class="homepage-feature-title">
        <h1 class="home-header">FEATURES</h1>
      </div>
      <div class="homepage-feature-section">
        <ul class="feature-list">
          <li class="feature-item">
            <div class="feature-information">
              <h1 class="home-header"><i class="fas fa-align-left"></i> Logging</h1>
              <div class="feature-description">
                <p>ModCord's performant logging lets you keep track and stay up to date with every update in your server with moderation, chat, server, voice and invite logs.</p>
              </div>
            </div>
            <div class="feature-image">
              <img v-bind:src="`${$cdnUrl}/assets/logger-showcase.png`" alt="Logger Feature Image">
            </div>
          </li>
          <li class="feature-item feature-reversed">
            <div class="feature-image">
              <img v-bind:src="`${$cdnUrl}/assets/automod-showcase.png`" alt="Automod Feature Image">
            </div>
            <div class="feature-information">
              <h1 class="home-header"><i class="fas fa-filter"></i> Automod</h1>
              <div class="feature-description">
                <p>ModCord's smart automod allows you to sleep at night with a clear mind knowing that your server is being kept clean of spam, malicious links, invites and so much much more.</p>
              </div>
            </div>
          </li>
          <li class="feature-item">
            <div class="feature-information">
              <h1 class="home-header"><i class="fas fa-shield-alt"></i> Security</h1>
              <div class="feature-description">
                <p>ModCord catches the bad actors before they get the chance to type the first letter with by checking users against a trusted ban list and automatically detecting raids.</p>
              </div>
            </div>
            <div class="feature-image">
              <img v-bind:src="`${$cdnUrl}/assets/security-showcase.png`" alt="Security Feature Image">
            </div>
          </li>
          <li class="feature-item feature-reversed">
            <div class="feature-image">
              <img v-bind:src="`${$cdnUrl}/assets/punishments-showcase.png`" alt="Automatic Punishment Feature Image">
            </div>
            <div class="feature-information">
              <h1 class="home-header"><i class="fas fa-hammer"></i> Auto Punishments</h1>
              <div class="feature-description">
                <p>ModCord helps you enforce rules consistently with it's intuitive system by letting you set up certain punishments to be applied when the user reaches a certain number of strikes.</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <Cookie />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Cookie from "@/components/Cookie.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Cookie,
    Footer
  },
  data () {
    return {
      guildCount: "###",
      memberCount: "###",
      thumbnail: {
        name: "command-showcase.png"
      }
    }
  },
  methods: {
    fetchGuildCount: async function () {
      const response = await this.$axios.get(`${this.$apiBase}/v1/stats/bot`);
      const data = response.data;
      this.guildCount = data.guild_count.toLocaleString();
      this.memberCount = data.member_count.toLocaleString();
    }
  },
  mounted () {
    this.fetchGuildCount();
  }
}
</script>

<style>
.homepage-hero {
  width: 100%;
  background-color: var(--black-blue);
  display: flex;
  align-content: center;
  justify-content: space-around;
  padding: 8% 3%;
}

.homepage-hero .brand-introduction {
  display: flex;
  flex-direction: column;
}

.home-header {
  font-size: 1.8em;
  line-height: 1.3em;
}

.homepage-hero .brand-introduction .brand-description {
  font-size: 1.1em;
  max-width: 22em;
  color: var(--plain-gray);
  line-height: 1.3em;
  margin: 1em auto;
}

.homepage-hero .brand-illustration {
  display: flex;
  align-items: center;
}

.homepage-hero .brand-illustration img {
  object-fit: cover;
  border-radius: 6px;
  transition: all .3s;
  width: 435px;
}

.homepage-hero .brand-illustration img:hover {
  width: 450px;
}

.homepage-hero .brand-introduction .brand-buttons a {
  display: inline-block;
}

.homepage-hero-wave {
  width: 100%;
  overflow: hidden;
}

.homepage-hero-wave img {
  width: 104%;
  position: relative;
  top: -0.3em;
}

.homepage-feature-wrapper {
  width: 100%;
  padding: 4% 2%;
}

.homepage-feature-wrapper .homepage-feature-title {
  width: 100%;
  text-align: center;
}

.homepage-feature-wrapper .homepage-feature-title h1 {
  font-size: 2em;
  margin-bottom: 2.5em;
}

.homepage-feature-wrapper .homepage-feature-section {
  width: 100%;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item {
  display: flex;
  justify-content: space-between;
  min-width: 85%;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item:not(:last-child) {
  margin-bottom: 6em;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image {
  display: flex;
  align-items: center;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image img {
  object-fit: cover;
  border-radius: 6px;
  transition: all .3s;
  width: 435px;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image img:hover {
  width: 440px;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-information {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-information .feature-description {
  max-width: 22em;
  color: var(--plain-gray);
  line-height: 1.3em;
  margin: 1em auto;
}

@media only screen and (max-width: 1050px) {
    .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image img {
    width: 360px;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image img:hover {
    width: 365px;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item {
    min-width: 95%;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-information .feature-description {
    max-width: 20em;
  }
}

@media only screen and (max-width: 960px) {
  .homepage-hero .brand-illustration img {
    width: 350px;
  }

  .homepage-hero .brand-illustration img:hover {
    width: 355px;
  }
}

@media only screen and (max-width: 830px) {
  .homepage-hero {
    justify-content: space-around;
    flex-direction: column;
    padding: 10% 4%;
  }

  .homepage-hero .brand-introduction {
    align-items: center;
  }

  .homepage-hero .brand-introduction .brand-description {
    max-width: 85%;
    text-align: center;
  }
    
  .homepage-hero .brand-introduction .brand-description p {
    text-align: center;
  }

  .homepage-hero .brand-illustration {
    margin-top: 1.9em;
    display: flex;
    justify-content: center;
  }

  .homepage-hero .brand-introduction .brand-title {
    text-align: center;
  }

  .homepage-hero .brand-illustration img {
    width: 77%;
  }

  .homepage-hero .brand-illustration img:hover {
    width: 79%;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item {
    flex-direction: column;
  }

  .feature-reversed {
    flex-direction: column-reverse!important;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-information {
    text-align: center;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-information .feature-description {
    max-width: 90%;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image {
    margin-top: 2.5em;
    justify-content: center;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image img {
    width: 80%;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item .feature-image img:hover {
    width: 82%;
  }

  .homepage-feature-wrapper .homepage-feature-section .feature-list .feature-item:not(:last-child) {
    margin-bottom: 4em;
  }
}

@media only screen and (max-width: 450px) {
  .homepage-hero .brand-illustration img {
    display: none;
  }

  .home-heaeder {
    font-size: 1.6em;
    line-height: 1.3em;
  }

  .homepage-hero .brand-introduction .brand-description {
    font-size: 1em;
  }

  .homepage-hero .brand-introduction .brand-buttons {
    text-align: center;
  }
}
</style>